import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            wt: number
            ct: number
        }
    }
}
export default class Microtime extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let time = <span></span>
        if (message) {
            time = (
                <span>
                    <Milliseconds value={message.args.wt} />
                </span>
            )
        }

        return (
            <div>
                <p>
                    Significant time {time} was spent in <code>microtime</code> calls.
                </p>
                <p>
                    Consider using <code>hrtime</code> instead or removing these calls to improve performance.
                </p>
            </div>
        )
    }
}
